/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

/** React library */
import { Component } from "react";

/** React redux */
import store from 'features/store';
import { connect } from "react-redux";

class LogOut extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: "Sign-In" } });
    }

    render() {
        return (
            <div></div>
        );
    }
}

export default connect(state => state)(LogOut);